<ng-container matColumnDef="revisionUsername">
  <mat-header-cell [crud-column-header]="columns.column('revisionUsername')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small revision-info-cell" i18n="@@type.Asset.revisionUsername">
    Username
  </mat-header-cell>
  <mat-cell class="search-column-small revision-info-cell" *matCellDef="let element">
    {{revisionEntityGetter(element)._revisionInfo?.username}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="revisionDate">
  <mat-header-cell [crud-column-header]="columns.column('revisionDate')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small revision-info-cell" i18n="@@type.Asset.revisionDate">
    Revision Date
  </mat-header-cell>
  <mat-cell class="search-column-small revision-info-cell" *matCellDef="let element">
    {{revisionEntityGetter(element)._revisionInfo?.revisionDate | uimDateTimeFormat}}
  </mat-cell>
</ng-container>